import React from 'react';
// import styles from './ValuationCode.scss';
import styles from './ValuationWidget.scss';
import HouseSvg from './HouseSvg';
import ApartmentSvg from './ApartmentSvg';
import { i18n, IValuationData } from './ValuationWidget';

export interface IValuationCodeProps {
    data: IValuationData;
    nextStep: (name: string, value: string) => void;
}

const ValuationCode: React.FC<React.PropsWithChildren<IValuationCodeProps>> = ({ data, nextStep = () => {} }) => {
    return (
        <div className={styles.options}>
            <div
                className={styles.option + ' ' + styles.house + ('house' === data.code ? ' ' + styles.active : '')}
                onClick={() => {
                    nextStep('code', 'house');
                }}
            >
                <div>
                    <HouseSvg variant="house" />
                </div>
                <span>{i18n.house.code}</span>
            </div>
            <div
                className={styles.option + ' ' + styles.apartment + ('apartment' === data.code ? ' ' + styles.active : '')}
                onClick={() => {
                    nextStep('code', 'apartment');
                }}
            >
                <div>
                    <ApartmentSvg variant="apartment" />
                </div>
                <span>{i18n.apartment.code}</span>
            </div>
        </div>
    );
};

export default ValuationCode;
